import React, { useEffect, useState } from "react";
import { createPortal } from "react-dom";
import { useTranslation } from "react-i18next";
import { getWhatsAppStatus } from "../../api";
import whatsappIcon from "../../components/Sidebar/assets/whatsapp.svg";
import styles from "./whatsapp.module.scss";

const SUPPORT_PHONE = "77084857101";

const SupportModal = ({ onClose, supportHref, t }) => {
  const [container] = useState(() => document.createElement("div"));
  useEffect(() => {
    document.body.appendChild(container);
    return () => document.body.removeChild(container);
  }, [container]);

  return createPortal(
    <div className={styles.restrictedOverlay} onClick={onClose}>
      <div className={styles.restrictedModal} onClick={(e) => e.stopPropagation()}>
        <button type="button" className={styles.restrictedClose} onClick={onClose}>
          ×
        </button>
        <h3>{t("NSWhatsapp.restrictedModalTitle")}</h3>
        <p>{t("NSWhatsapp.restrictedModalDesc")}</p>
        <a
          href={supportHref}
          target="_blank"
          rel="noopener noreferrer"
          className={styles.restrictedCta}
        >
          <img
            src={whatsappIcon}
            alt="WhatsApp"
            style={{ width: 20, height: 20, marginRight: 8 }}
          />
          {t("NSWhatsapp.restrictedModalCta")}
        </a>
      </div>
    </div>,
    container
  );
};

const PersonalChannelRestrictedBanner = ({ branchID, branchName }) => {
  const { t } = useTranslation();
  const [restricted, setRestricted] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (!branchID) return;
    let cancelled = false;
    getWhatsAppStatus(branchID)
      .then((res) => {
        if (cancelled) return;
        const state = res?.data?.stateInstance || "";
        setRestricted(state === "yellowCard" || state === "blocked");
      })
      .catch(() => {
        if (!cancelled) setRestricted(false);
      });
    return () => {
      cancelled = true;
    };
  }, [branchID]);

  if (!restricted) return null;

  const idPart = branchID ? ` (id ${branchID})` : "";
  const prefill = encodeURIComponent(
    `${t("NSWhatsapp.restrictedSupportPrefill")} ${branchName || ""}${idPart}`.trim()
  );
  const supportHref = `https://wa.me/${SUPPORT_PHONE}?text=${prefill}`;

  return (
    <div className={styles.restrictedBanner}>
      <div className={styles.restrictedBannerText}>
        <div className={styles.restrictedBannerTitle}>
          {t("NSWhatsapp.restrictedTitle")}
        </div>
        <div className={styles.restrictedBannerDesc}>
          {t("NSWhatsapp.restrictedDesc")}
        </div>
      </div>
      <button
        type="button"
        className={styles.restrictedBannerButton}
        onClick={() => setOpen(true)}
      >
        {t("NSWhatsapp.restrictedButton")}
      </button>
      {open && (
        <SupportModal onClose={() => setOpen(false)} supportHref={supportHref} t={t} />
      )}
    </div>
  );
};

export default PersonalChannelRestrictedBanner;
